<template>
    <div>
      <v-card width="100%" v-if="current">
        <v-card-title>Status das OLTs</v-card-title>
        <v-card-text>
          <div v-if="current"><strong>OLT: </strong> {{ olt.name }}</div>
          <v-simple-table>
            <thead>
                <tr>
                    <th>Interface</th>
                    <th>Total</th>
                    <th>UP</th>
                    <th>DOWN</th>
                    <th>Exportar</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in current" :key="index" :style="bgItem(item)">
                    <td>{{ item.name }}</td>
                    <td>{{ item.total }}</td>
                    <td>{{ item.active }}</td>
                    <td>{{ (item.inactive+item.invalid) }}</td>
                    <td>
                        <v-btn icon small color="primary" :title="'Exportar ONTs da porta ' + item.name" @click="exportONTs(item)">
                            <v-icon>mdi-download</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>

      <v-dialog v-model="dialog_loading" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Por favor aguarde
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
import api from "../../api/index.js";
export default {
    data: () => ({
        current: null,
        olt: null,
        dialog_loading: false
    }),
    created: function() {
        this.load();
        this.loadOlt();
    },
    methods: {
        load: function(){
            var me = this;
            var token = localStorage.getItem("token");
            api
                .get("/olt/status/" + this.$route.params.id, { headers: { Authorization: "Bearer " + token } })
                .then(function(response) {
                    me.current = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadOlt: function(){
            var me = this;
            var token = localStorage.getItem("token");
            api
                .get("/olt/" + this.$route.params.id, { headers: { Authorization: "Bearer " + token } })
                .then(function(response) {
                    me.olt = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        bgItem: function(item){
            let dp = (item.inactive + item.invalid) / item.total;
            console.log(dp);
            if(dp > 0.4){
                return {
                    backgroundColor: '#ff6961'
                };
            } else if(dp > 0.2){
                return {
                    backgroundColor: '#fdfd96'
                };
            }
        },
        exportONTs: function(item){
            var me = this;
            var token = localStorage.getItem("token");
            //o status devolve a interface como "gpon1/1", a ONT guarda apenas "1/1"
            var port = item.name.replace(/^gpon\s*/i, "").trim();
            me.dialog_loading = true;
            api
                .get("/ont/olt/" + this.$route.params.id + "?port=" + encodeURIComponent(port), { headers: { Authorization: "Bearer " + token } })
                .then(function(response) {
                    me.dialog_loading = false;
                    if(!response.data || response.data.length == 0){
                        alert("Nenhuma ONT encontrada na porta " + item.name + "!");
                        return;
                    }
                    me.downloadTXT(response.data, item);
                })
                .catch(function(error) {
                    me.dialog_loading = false;
                    alert("Falha ao exportar as ONTs!");
                    console.log(error);
                });
        },
        downloadTXT: function(onts, item){
            var lines = [];
            for(var i = 0; i < onts.length; i++){
                lines.push(onts[i].serial);
            }
            var blob = new Blob([lines.join("\r\n")], { type: "text/plain;charset=utf-8;" });
            var port = item.name.replace(/^gpon\s*/i, "").trim().replace(/[^a-zA-Z0-9]+/g, "_");
            var url = URL.createObjectURL(blob);
            var link = document.createElement("a");
            link.href = url;
            link.download = "parks-" + this.$route.params.id + "-" + port + ".txt";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }
    }
}
</script>